<template>
    <div v-if="adoptionData">
        <b-container v-if="!postedForm && !adoptionData">Loading...</b-container>
        <b-container class="" v-else-if="!postedForm && adoptionData">
            <b-form @submit.prevent="postUpdates">
                <!-- Contact Info -->
                <b-row class="">
                    <b-col>
                        <b-input-group prepend="School Name:" class="mb-2"> <b-input v-model="formData.schoolname" required /></b-input-group>
                        <b-input-group prepend="Address:" class="mb-2"> <b-input v-model="formData.address" required /></b-input-group>
                        <b-input-group prepend="City:" class="mb-2"> <b-input v-model="formData.city" required /></b-input-group>
                        <b-input-group prepend="State:" class="mb-2"> <b-input v-model="formData.state" required /></b-input-group>
                        <b-input-group prepend="Zipcode:" class="mb-2"> <b-input v-model="formData.zip" required /></b-input-group>
                    </b-col>
                    <b-col>
                        <b-input-group prepend="Contact:" class="mb-2"> <b-input v-model="formData.contactName" name="name" placeholder="First & Last Name" required /></b-input-group>
                        <b-input-group prepend="Phone:" class="mb-2"> <b-input v-model="formData.phone" name="phone" :formatter="phoneFormatter" placeholder="(111) 222-3333" required /></b-input-group>
                        <b-input-group prepend="Email:" class="mb-2"> <b-input v-model="formData.email" name="email" placeholder="example@email.com" required /></b-input-group>
<!--                        <b-input-group prepend="Optional Email:" class="mb-2"> <b-input v-model="formData.email" name="email" placeholder="example@email.com" /></b-input-group>-->
                        <b-input-group prepend="School Start Date"  class="mb-2">
                            <!--                    <label>School Start Date</label>-->
                            <v-date-picker v-model="openday">
                                <template v-slot="{ inputValue, inputEvents }">
                                    <b-input
                                        :value="inputValue"
                                        v-on="inputEvents"
                                    />
                                </template>
                            </v-date-picker>
                        </b-input-group>

                        <!-- Shipment Deadline -->
                        <b-input-group prepend="Shipment Delivery Deadline">
                            <!--                    <label>Shipment Delivery Deadline</label>-->
                            <v-date-picker v-model="deliveryday">
                                <template v-slot="{ inputValue, inputEvents }">
                                    <b-input
                                        :value="inputValue"
                                        v-on="inputEvents"
                                    />
                                </template>
                            </v-date-picker>
                        </b-input-group>
                    </b-col>
                </b-row>
                <!-- Blackout Windows -->
                <b-row>
                    <b-col>
                    <div class="mt-1">
                        <div ref="blackoutWindow">Select date ranges that you are <strong style="color: red;">NOT</strong> available to receive shipment</div>
                        <div class="mt-2"><b-checkbox id="blackout_none" v-model="blackoutNoWindows" name="blackoutNoWindows">I can receive shipment at any time</b-checkbox></div>
                        <!-- Blackout Window -->
                        <div v-show="!blackoutNoWindows">
                            <div v-for="(blackoutWindow, i) in blackoutWindows" :key="`window_${i}`">
                                <v-date-picker
                                    class="mt-1"
                                    mode="range"
                                    is-range
                                    color="purple"
                                    v-model="blackoutWindows[i]"
                                    :disabled-dates="getDisabledDates(i)"
                                    :columns="$screens({ default: 1, lg: 2 })"
                                    :rows="$screens({ default: 2, lg: 1 })"
                                    show-caps
                                    is-inline
                                    is-double-paned
                                    @input="validateRange($event, i)"
                                    :ref="`blackoutWindow_${i}`"
                                />
                                <b-input-group
                                    class="mt-1 w-75 date-label"
                                    @click="toggleWindow(i)"
                                >
                                    <template #prepend>
                                        <b-input-group-text><font-awesome-icon :icon="['fas','calendar-times']"></font-awesome-icon></b-input-group-text>
                                    </template>
                                    <b-form-input
                                        type="text"
                                        class="date-label"
                                        :value="dateRangeText(blackoutWindows[i])"

                                        readonly
                                    ></b-form-input>
                                    <template #append>
                                        <b-button type="link" variant="danger" size="sm" @click="deleteWindow(i)">
                                            <font-awesome-icon :icon="['fas','trash-alt']"></font-awesome-icon>
                                        </b-button>
                                    </template>
                                </b-input-group>
                            </div>
                            <div class="text-danger">{{arriveWindowRangeError}}</div>
                            <b-button type="button"
                                      size="sm"
                                      variant="success"
                                      @click="addWindow()"
                                      :disabled="blackoutWindows.length >= 5"
                                      class="mt-3">
                                Add Date Range
                            </b-button>
                        </div>
                    </div>
                    </b-col>
                </b-row>

                <b-row class="mt-4">
                    <!-- Display adoption type -->
                    <h3 class="my-0">
                        <!--                            {{customerInfo.adoption_type}}-->
                        <template v-if="customerInfo.adoption_type === 'SS'">Social Studies</template>
                        <template v-if="customerInfo.adoption_type === 'SCI'">Science</template>
                        <template v-if="customerInfo.adoption_type === 'SS|SCI' || customerInfo.adoption_type === 'SCI|SS'">Social Studies & Science</template>
                        Adoption
                    </h3>
                </b-row>
                <!-- Series Selection -->
                <b-row class="w-50" v-if="adoptionSeries.length > 1">
                    <label class="d-inline">Additional Adoptions (Listed by PO Number):  </label>
                    <b-select class="d-inline w-75" :value="seriesId" @input="resetAdoptionSeries">
                        <b-select-option v-for="(series, i) in adoptionSeries" :value="series.series_id" :key="'series_option_'+i">
                            {{series.data.misc.po_number}}
                        </b-select-option>
                    </b-select>
                </b-row>

                <!-- Product Quantities -->
                <b-row class="mt-3">
                <b-table v-if="skuQuantities" striped :items="Object.values(skuQuantities)" :fields="gradeFields">
                    <template #cell(qty)="data">
                        <b-input type="number" min="0" v-model="skuQuantities[data.item.sku].qty"></b-input>
                    </template>
                    <template #cell(teachers)="data">
                        <b-input type="number" min="0" v-model="skuQuantities[data.item.sku].teachers"></b-input>
                    </template>
                </b-table>
            </b-row>

            <div class="float-right">
                <b-btn type="submit" variant="primary" size="lg" :disabled="saving">
                    Submit
                </b-btn>
            </div>
            </b-form>
        </b-container>
        <b-container class="" v-else>
            <h4>Thank you for submitting your request.</h4>
            <p>Our adoption team will review these updates and get back to you soon.</p>
        </b-container>
    </div>

</template>

<script>

import Vue from 'vue'
import VueAnalytics from 'vue-analytics'

import Calendar from 'v-calendar/lib/components/calendar.umd'
import DatePicker from 'v-calendar/lib/components/date-picker.umd'

import moment from 'moment'
import AdoptionNavbar from "@/components/adoptions/AdoptionNavbar";
import {mapState} from "vuex";

Vue.use(require('vue-moment'))

export default {
    name: "UpdateAdoption",
    components: {
        AdoptionNavbar,
        Calendar,
        DatePicker,
    },
    props: {
        'customerId': {},
    },
    data: () => ({
        // Display Data
        saving: false,
        postedForm: false,
        blackoutNoWindows: false,
        blackoutWindows: [],
        arriveWindowRangeError: null,
        isLoadingAdoption: false,
        startDate: null,

        // Updated Adoption Data
        openday: null,
        deliveryday: null,
        formData: {
            schoolname: null
        },
    }),
    computed: {
        ...mapState({
            seriesId: state => state.adoption.seriesId,
            adoptionData: state => state.adoption.adoptionData.data,
            adoptionSeries: state => state.adoption.series,
            contacts: state => state.adoption.contacts,
        }),
        blackoutDates() {
            let dates = this.adoptionData.blackouts.map((i) => ({
                start: new Date(i.start_date*1000),
                end: new Date(i.end_date*1000)
            }));
            console.log(dates);
            return dates;
        },
        owners() {
            let items = [];
            let data = this.adoptionData.misc.owner;
            let keys = Object.keys(data);
            for (let i = 0; i < keys.length; ++i) {

                // Remove Invoice Managers
                if (keys[i] == "Invoice Manager")
                    continue;

                // Check duplicates
                let name = data[keys[i]].name;
                let email = data[keys[i]].email;
                if (this.agentDuplicates[name] || this.agentDuplicates[email]) {
                    continue;
                }

                // Reformat data array
                let key = keys[i];
                data[key]['type'] = key;
                items.push(data[key]);

                // Push keys to duplicate check object.
                this.agentDuplicates[name] = 1;
                this.agentDuplicates[email] = 1;
            }
            return items;
        },
        customerInfo() {
            if (!this.adoptionData.misc)
                return {};

            this.adoptionData.misc.startyear = parseInt(this.adoptionData.misc.startyear);
            this.adoptionData.misc.endyear = parseInt(this.adoptionData.misc.endyear);
            return this.adoptionData.misc;
        },
        studiesWContact() {
            return this.customerInfo.studiesw_contact;
        },
        schoolStartDate() {
            var date = new Date(parseInt(this.customerInfo.school_start_date) * 1000);
            date.setFullYear(new Date().getFullYear());
            return date;
        },
        gradeFields() {
            // TODO: billed_each_year
            // Remove some fields
            if (this.customerInfo.grades_only) {
                return ['grade', {
                    key: 'qty',
                    label: 'Quantity'
                }, 'teachers']
            }

            // Show all fields
            let fields = ['grade', 'sku'];

            fields.push({
                key: 'qty',
                label: 'Quantity'
            })
            fields.push('teachers');
            return fields;
        },
        invoices() {
            let invoices = [];
            let currentYear = new Date().getFullYear();
            for (let topic in this.adoptionData.sections_shipped) {
                for (let year in this.adoptionData.sections_shipped[topic]) {
                    if (year != currentYear+1)
                        continue;

                    for (let index in this.adoptionData.sections_shipped[topic][year]) {
                        let invoice = this.adoptionData.sections_shipped[topic][year][index];
                        if (invoices.indexOf(invoice['ID']) == -1)
                            invoices.push(invoice['ID'])
                    }
                }
            }
            console.log("invoices: ", invoices);
            return invoices;
        },
        skuQuantities() {
            let skuQuantities = {};
            let data = this.adoptionData.grades;
            let grades = Object.keys(data);

            for (let i = 0; i < grades.length; ++i) {
                let grade = grades[i];
                let skus = Object.keys(data[grade]);

                let item = {};
                for (let j = 0; j < skus.length; ++j) {
                    let sku = skus[j];
                    let item = data[grade][sku];
                    // console.log(item);
                    item['grade'] = grade;
                    item['sku'] = sku;
                    item['qty'] = parseInt(item['qty']);
                    item['teachers'] = parseInt(item['teachers']);

                    skuQuantities[sku] = Object.assign({}, item);
                }
            }
            // console.log(items);
            console.log("skuQty", skuQuantities);
            return skuQuantities;
        },
    },
    methods: {
        getAdoptionData() {
            // TODO move to store.
            this.isLoadingAdoption = true;
            return new Promise((resolve, reject) => {
                this.axios.get(`/adoption/${this.customerId}`).then((response) => {
                    if (!response || !response.data || !response.data.adoption_data) {
                        reject();
                        return;
                    }
                    resolve(response.data);
                })
                    .catch((err) => {
                        this.loadError = `${err} <br/> ${err.response.data}`;
                        console.log(err);
                        reject(err);
                    })
                    .finally(() => this.isLoadingAdoption = false);
            });
        },
        postUpdates() {
            this.saving = true;
            let data = {
                ...this.formData,
                quantities: this.skuQuantities,
                no_shipping_restrictions: this.blackoutNoWindows,
                blackout_windows: this.mergeWindows(),
                openday: this.openday,
                deliveryday: this.deliveryday,
                purchase_order: this.customerInfo.po_number,
                invoices: this.invoices,
                adoption_type: this.customerInfo.adoption_type,
                series_id: this.adoptionData.series_id
            }
            this.axios.post('/adoption/updateRequest', data)
                .then((response) => {
                    this.postedForm = true;
                })
                .catch((e) => {
                    this.$swal({
                        toast: true,
                        html: `An error occurred. Please contact support. <br/>${e}`,
                        type: 'error',
                        position: 'top-end',
                        showConfirmButton: false,
                        noAutoHide: true
                    });
                })
                .finally(() => {
                    this.saving = false;
                })
        },
        // BLACKOUT WINDOWS
        mergeWindows() {
            if (this.blackoutWindows.length === 0 || this.blackoutNoWindows)
                return [];

            let finalWindows = [];
            let windows = JSON.parse(JSON.stringify(this.blackoutWindows));
            // Sort by date ASC
            windows.sort((a, b) => {
                return new Date(a.start) - new Date(b.start);
            });

            // Check each window against the others, todo: figure out new algo for this.
            for (let i = 0; i < windows.length; ++i) {
                if (!windows[i].start || !windows[i].end)
                    continue;

                const windowA = windows[i];
                let newWindow = {start: new Date(windowA.start), end: new Date(windowA.end)};

                // Compare each date against the current window
                for (let j = 0; j < windows.length; ++j) {
                    if (j === i)
                        continue;

                    let windowB = {start: new Date(windows[j].start), end: new Date(windows[j].end)};

                    // A is not before B
                    if (newWindow.end > windowB.end)
                        continue;

                    // Date Diffs
                    const endToStartDiff = newWindow.end - windowB.start;
                    const endToStartDays = endToStartDiff / (1000 * 64 * 64 * 24);

                    // B is withing 2 weeks of A
                    if (endToStartDays > -13) {
                        newWindow.end = windowB.end;
                        windows.splice(j,1);
                        j--;
                    }
                }
                windows[i] = newWindow;
                finalWindows.push(newWindow);
            }
            return finalWindows;
        },
        addWindow() {
            this.blackoutWindows.push({start: null, end: null});
        },
        deleteWindow(i) {
            this.blackoutWindows.splice(i, 1);
        },
        toggleWindow(i) {
            let el =  this.$refs[`blackoutWindow_${i}`][0].$el;
            if (el.style.display !== 'none') {
                el.style = 'display: none';
                return;
            }
            el.style = 'display: block';
        },
        getDisabledDates(i) {
            // Get all items in blackoutWindows except the current (i-th) element
            return this.blackoutWindows.filter((element, index) => {
                return index !== i;
            });
        },
        dateRangeText(dateRange) {
            if (!dateRange || !dateRange.end)
                return null;

            let startDate = new Date(dateRange.start).toLocaleDateString('en-US');
            let endDate = new Date(dateRange.end).toLocaleDateString('en-US');

            return `${startDate} ~ ${endDate}`;
        },
        validateRange (event, windowIndex) {
            if (!event || !event.start) return;

            var windowStart = moment(event.start);
            var windowEnd = moment(event.end);
            this.arriveWindowRangeError = null;

            // Hide datepicker
            this.$refs[`blackoutWindow_${windowIndex}`][0].$el.style = 'display: none;';
        },
        // End blackout window functions
        getGradeValue(grade) {
            if (grade === 'Kindergarten')
                return 0;
            return parseInt(grade.replace(/(Grade )/, ""));
        },
        phoneFormatter(phoneVal, event) {
            // Replace template/mask parts
            let val = phoneVal.replaceAll(/[\(\)\- ]*/g, '');
            if (val === '')
                return '';

            // Get parts
            let parts = val.split('');
            let firstThree = parts.slice(0,3).join('');
            let secondThree = parts.slice(3,6).join('');
            let rest = parts.slice(6).join('');

            // Create masked value
            let template = `(${firstThree}`
            if (secondThree !== '')
                template += `) ${secondThree}`;
            if (rest !== '')
                template += `-${rest}`;
            return template;
        },
        resetAdoptionSeries(seriesId) {
            if (!seriesId)
                return;

            this.$store.commit('setAdoptionSeries', seriesId)
        }
    },
    mounted() {
        this.$zendesk.show();
        this.openday = this.schoolStartDate;
        this.formData.schoolname = this.customerInfo.schoolname;
        this.formData.address = this.customerInfo.billingaddress;
        this.formData.city = this.customerInfo.billingcity;
        this.formData.state = this.customerInfo.billingstate;
        this.formData.zip = this.customerInfo.billingzip;

        console.log('blackouts: ', this.blackoutDates)

    },
    created() {
    }
}
</script>

<style scoped>

</style>